<template>
  <div class="w-full text-whitebase pt-12 relative pb-28" ref="container">
    <div class="flex w-full">
      <div class="flex-1 h-full min-w-0 pr-6 relative">
        <div class="text-xl mb-4 font-bold">Basic information</div>
        <div class="space-y-4">
          <div class="">
            <div class="text-black flex mb-3">
              <div class="flex items-start" style="color: #ff5585ff">
                <div class="h-1 w-1 rounded-full bg-inputActive"></div>
              </div>
              <span> DAO logo </span>
            </div>
            <PhotoUpload
              v-model="formInfo.logo"
              :size="136"
              name="DAO logo"
            ></PhotoUpload>
          </div>

          <div class="flex">
            <div class="flex-1 space-y-4">
              <UiInput
                ref="nameInput"
                label="DAO name"
                v-model="formInfo.name"
                placeholder="Enter DAO Name"
                required
                :maxLength="60"
                :rules="['normalStr']"
                showError
              ></UiInput>
              <UiTextarea
                ref="introInput"
                label="Introduction"
                v-model="formInfo.intro"
                placeholder="Please Enter"
                required
                :maxLength="280"
                :minLength="64"
                rows="8"
                showError
              ></UiTextarea>
            </div>
          </div>

          <div>
            <div class="flex mb-3">
              <div class="flex items-start" style="color: #ff5585ff">
                <div class="h-1 w-1 rounded-full bg-inputActive"></div>
              </div>
              <div>NFT/DEFI DAO</div>
            </div>

            <div class="space-x-4 flex" style="width: fit-content">
              <div
                class="font-bold flex items-center px-4 rounded h-14"
                style="border: 1px solid #2a2e33"
              >
                <UiCheckBox
                  :modelValue="formInfo.daoCategory == 0"
                  @update:modelValue="() => (formInfo.daoCategory = 0)"
                >
                  <span> NFT DAO </span>
                </UiCheckBox>
              </div>

              <div
                class="font-bold flex items-center px-4 rounded h-14"
                style="border: 1px solid #2a2e33"
              >
                <UiCheckBox
                  :modelValue="formInfo.daoCategory == 1"
                  @update:modelValue="() => (formInfo.daoCategory = 1)"
                >
                  <span> DEFI DAO </span>
                </UiCheckBox>
              </div>
            </div>
          </div>

          <div class="w-48">
            <UiDropdown
              label="DAO Type"
              v-model="state.daoType"
              :options="daoTypes"
              required
              boxStyle="drop-height"
              placeholder="Select"
            ></UiDropdown>
          </div>

          <div>
            <div class="text-black flex mb-3">
              <div class="flex items-start" style="color: #ff5585ff">
                <div class="h-1 w-1 rounded-full bg-inputActive"></div>
              </div>
              <span> DAO Tag </span>
            </div>
            <div class="flex flex-wrap">
              <div
                class="w-2/5 mr-4 mb-2 relative"
                v-for="(tag, i) in state.tags"
                :key="tag.id"
              >
                <UiInput
                  v-model="tag.value"
                  :placeholder="
                    i == 0 ? 'First tag' : i == 1 ? 'Second tag' : ''
                  "
                ></UiInput>
                <i
                  class="
                    iconfont
                    icon-guanbi
                    absolute
                    -right-1
                    -top-1
                    text-xs
                    cursor-pointer
                  "
                  v-if="i > 1"
                  @click="delTag(i)"
                ></i>
              </div>
              <div class="flex items-center mb-2 cursor-pointer">
                <div
                  v-if="state.tags.length < 5"
                  @click="addTag"
                  class="
                    w-16
                    h-8
                    rounded
                    bg-mb-red
                    font-bold
                    text-xs
                    flex
                    items-center
                    justify-center
                  "
                >
                  <i class="iconfont icon-tianjia-46 text-xs"></i> Add
                </div>
              </div>
            </div>
            <div class="text-xs text-white-070">
              Please insert at least 2 tags about the DAO
            </div>
          </div>
        </div>
      </div>

      <div style="width: 368px">
        <div class="text-xl mb-4 font-bold">Social media</div>
        <div class="relative">
          <div class="space-y-4">
            <UiInput
              ref="websiteInput"
              label="Website"
              v-model="formInfo.website"
              placeholder="https://example.com"
              required
              showError
            ></UiInput>

            <div>
              <UiInput
                label="Twitter"
                ref="twitterInput"
                v-model="formInfo.twitter"
                placeholder="https://twitter.com/example"
                required
                showError
              ></UiInput>
              <div class="text-xs text-white-070 mt-2">
                (Don't forget to verify your Twitter account to get bluechip
                <img
                  class="w-3 h-3 inline"
                  src="@/assets/icons/tw_ok.avif"
                  alt=""
                />
                on your live page after everything is done!)
              </div>
            </div>

            <UiInput
              label="Mirror"
              v-model="formInfo.mirrorUrl"
              placeholder="Mirror"
            ></UiInput>

            <UiInput
              label="Discord"
              v-model="formInfo.discordLinkUrl"
              placeholder="Discord"
            ></UiInput>
            <UiInput
              label="Telegram"
              v-model="formInfo.telegramLinkUrl"
              placeholder="Telegram"
            ></UiInput>
            <UiInput
              label="Whitepaper"
              v-model="formInfo.whitepaper"
              placeholder="Whitepaper"
            ></UiInput>
            <UiInput
              label="Opensea"
              v-model="formInfo.openseaUrl"
              placeholder="Opensea"
            ></UiInput>
            <UiInput
              label="SuperRare"
              v-model="formInfo.superrareUrl"
              placeholder="SuperRare"
            ></UiInput>
            <UiInput
              label="Foundation"
              v-model="formInfo.foundationUrl"
              placeholder="Foundation"
            ></UiInput>

            <div>
              <div class="text-black text-xl font-bold mb-3">
                <span>For More</span>
              </div>

              <div
                v-for="(link, i) in state.externalLinks"
                :key="link.id"
                class="flex mb-4 relative"
              >
                <div class="mr-6" style="flex-basis: 33.3%">
                  <UiInput placeholder="Name" v-model="link.name"></UiInput>
                </div>
                <div style="flex-basis: 66.7%">
                  <UiInput placeholder="URL" v-model="link.value"></UiInput>
                </div>
                <div
                  v-if="i != 0"
                  class="absolute -right-1 -top-1 cursor-pointer"
                  @click="delLink(i)"
                >
                  <i class="iconfont icon-guanbi text-xs"></i>
                </div>
              </div>

              <div
                @click="addLink"
                class="
                  w-16
                  h-8
                  rounded
                  bg-mb-red
                  font-bold
                  text-xs
                  flex
                  items-center
                  justify-center
                  cursor-pointer
                  mt-2
                "
              >
                <i class="iconfont icon-tianjia-46 text-xs"></i> Add
              </div>
            </div>

            <div class="space-y-4">
              <div class="font-bold text-xl">Structure</div>
              <div class="text-white-070 text-xs">
                If the DAO belongs to any other DAO or the DAO has the structure
                of sudDAO, please kindly insert the introduction and relations
                of other DAOs.
              </div>

              <UiTextarea
                v-model="formInfo.structure"
                placeholder="Structure introduction"
              ></UiTextarea>

              <div>DAO Relationship</div>
              <div
                class="flex space-x-4 relative"
                v-for="(item, i) in state.daoRelations"
                :key="item.id"
              >
                <UiDropdown
                  noBorder
                  style="border: 1px solid rgba(255, 255, 255, 0.15)"
                  class="w-36 rounded"
                  v-model="item.relationshipType"
                  :options="daoRelations"
                  placeholder="Relation"
                  boxStyle="drop-height"
                ></UiDropdown>

                <SearchCell
                  placeholder="Select DAO"
                  v-model="item.dao"
                ></SearchCell>
                <div
                  v-if="i != 0"
                  class="absolute -right-1 -top-1 cursor-pointer"
                  @click="delRelation(i)"
                >
                  <i class="iconfont icon-guanbi text-xs"></i>
                </div>
              </div>
              <div
                class="
                  w-16
                  h-8
                  rounded
                  bg-mb-red
                  font-bold
                  text-xs
                  flex
                  items-center
                  justify-center
                  cursor-pointer
                  mt-2
                "
                @click="addRelation"
              >
                <i class="iconfont icon-tianjia-46 text-xs"></i> Add
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="fixed bg-white pb-6" :style="`bottom:0;width:${width}px`">
    <div
      class="h-14 w-full rounded flex justify-end items-center px-4"
      style="background: #2a2b2d"
    >
      <div v-if="isEditDao" class="ready-btn" @click="doNext(true)">SAVE</div>
      <div v-else class="ready-btn" @click="doNext()">NEXT</div>
    </div>
  </div>

  <Dialog
    :visible="state.show"
    :text="state.showText"
    alert
    @close="state.show = false"
  ></Dialog>
</template>

<script setup>
import { checkDaoExsit, editDao, onlyCreateDao } from '@/api/dao';
import Dialog from '@/components/Dialog.vue';
import { useUserInfo } from '@/hooks';
import { uuid } from '@/utils';
import { withLoading, withThrottling, withWalletLogin } from '@/utils/with';
import { notify } from '@kyvg/vue3-notification';
import { useElementSize } from '@vueuse/core';
import { computed, inject, onMounted, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import UiDropdown from './component/UiDropdown.vue';
import PhotoUpload from './component/PhotoUpload.vue';
import SearchCell from './component/SearchCell.vue';
import UiInput from './component/UiInput.vue';
import UiTextarea from './component/UiTextarea.vue';
import { useIsEditDao } from './constanst';
import UiCheckBox from '@/components/CheckBox.vue';

const container = ref(null);

const $router = useRouter();
const { width } = useElementSize(container);
const userInfo = useUserInfo();
const isEditDao = useIsEditDao();

const formInfo = inject('formInfo');
const createState = inject('createState');

const nameInput = ref(null);
const introInput = ref(null);
const websiteInput = ref(null);
const twitterInput = ref(null);

const daoRelations = [
  { label: 'Parent', value: '1' },
  { label: 'Sub', value: '2' },
];

const daoTypes = computed(() => {
  return formInfo.daoCategory == 0
    ? [
        { label: 'Infrastructure' },
        { label: 'Protocol DAO' },
        { label: 'Investment DAO' },
        { label: 'Collector DAO' },
        { label: 'Guild' },
        { label: 'Creator DAO' },
        { label: 'Service DAO' },
        { label: 'Media DAO' },
        { label: 'Grant DAO' },
      ]
    : [
        { label: 'Infrastructure' },
        { label: 'Protocol DAO' },
        { label: 'Investment DAO' },
        { label: 'Service DAO' },
        { label: 'Grant DAO' },
      ];
});

const state = reactive({
  name: '',
  daoLogo: '',
  daoType: '',
  daoRelations: [{ id: uuid(), relationshipType: { label: '' }, dao: {} }],
  tags: [
    { id: uuid(), value: '' },
    { id: uuid(), value: '' },
  ],
  externalLinks: [{ id: uuid(), value: '', name: '' }],
  daoExsited: false,
  canSubmit: false,
  show: false,
});

const addTag = () => {
  state.tags.push({ id: uuid(), value: '' });
};
const delTag = (i) => {
  state.tags.splice(i, 1);
};

const addLink = () => {
  state.externalLinks.push({ id: uuid(), value: '', name: '' });
};
const delLink = (i) => {
  state.externalLinks.splice(i, 1);
};

const addRelation = () => {
  state.daoRelations.push({
    id: uuid(),
    relationshipType: { label: '' },
    dao: {},
  });
};
const delRelation = (i) => {
  state.daoRelations.splice(i, 1);
};

const createDao = withThrottling(
  withLoading(async function () {
    const {
      name,
      intro,
      logo,
      website,
      whitepaper,
      twitter,
      openseaUrl,
      superrareUrl,
      foundationUrl,
      customizeLink,
      discordLinkUrl,
      telegramLinkUrl,
      daoTag,
      daoType,
      mirrorUrl,
      daoCategory,
      daoRelationship,
      structure,
    } = formInfo;

    const params = {
      name,
      intro,
      logo,
      website,
      whitepaper,
      twitter,
      openseaUrl,
      superrareUrl,
      foundationUrl,
      customizeLink,
      discordLinkUrl,
      telegramLinkUrl,
      daoTag,
      daoType,
      mirrorUrl,
      daoCategory,
      daoRelationship,
      structure,
    };

    try {
      if (formInfo.id) {
        await editDao({
          id: formInfo.id,
          ...params,
        });
      } else {
        const id = await onlyCreateDao(params);
        formInfo.id = id;
        formInfo.createDaoTime = Date.now();
      }
    } catch (error) {
      notify({
        type: 'error',
        text: error.msg,
      });
    }
  }),
);

const checkForm = () => {
  let isRule = true;
  [nameInput, introInput, websiteInput, twitterInput].forEach((val) => {
    if (!isRule) {
      return;
    }
    isRule = !val.value.checkRule();
  });

  if (
    !formInfo.logo ||
    state.daoExsited ||
    state.tags.filter((x) => !!x.value).length < 2
  ) {
    // TODO Tip
    isRule = false;
  }
  return isRule;
};

const checkAll = () => {
  let isRule = true;

  if (!formInfo.logo) {
    state.show = true;
    state.showText = 'No logo selected';
    return false;
  }

  [nameInput, introInput].forEach((val) => {
    if (!isRule) {
      return;
    }
    const msg = val.value.checkRule();
    state.showText = msg;
    isRule = !msg;
  });

  if (!isRule) {
    state.show = true;
    return false;
  }

  if (state.tags.filter((x) => !!x.value).length < 2) {
    state.showText = 'Please insert the tags correctly!';
    state.show = true;
    return false;
  }

  [websiteInput, twitterInput].forEach((val) => {
    if (!isRule) {
      return;
    }
    const msg = val.value.checkRule();
    state.showText = msg;
    isRule = !msg;
  });

  if (!isRule) {
    state.show = true;
    return false;
  }

  return true;
};

const doNext = withWalletLogin(async (isEdit) => {
  if (formInfo.name && state.name !== formInfo.name) {
    const prev = formInfo.name;
    const flag = !(await checkDaoExsit(prev));
    if (prev == formInfo.name && flag) {
      state.show = true;
      state.showText = 'DAO Name has exsited.';
      return;
    }
  }

  if (!checkAll()) {
    return;
  }

  if (!formInfo.daoType) {
    state.show = true;
    state.showText = 'DAO Type not selected!';
    return;
  }

  await createDao();

  if (isEdit) {
    notify({
      type: 'success',
      text: 'Update Dao Info Successfully.',
    });
  } else {
    createState.daoStatus = true;
    formInfo.creatorRole = {
      id: uuid(),
      time: Date.now(),
      address: userInfo.value.address,
    };

    $router.replace('/create/passsettings');
  }
});

['name', 'logo', 'intro', 'daoTag', 'website', 'twitter'].forEach((key) => {
  watch(
    () => JSON.stringify(formInfo[key]),
    async (value) => {
      const val = JSON.parse(value);

      if (key === 'name' && val) {
        const prev = val;
        const flag = !(await checkDaoExsit(val));
        if (prev == formInfo[key]) {
          state.daoExsited = flag;
          nameInput.value.setErrorMsg(flag ? 'DAO has exsited.' : '');
        }
      }
      state.canSubmit = checkForm();
    },
  );
});

watch(
  () => state.daoType.label,
  (val) => {
    formInfo.daoType = val;
  },
);

watch(
  () => JSON.stringify(state.externalLinks),
  (val) => {
    console.log(val);
    formInfo.customizeLink = JSON.parse(val)
      .filter((x) => !!x.name && x.value)
      .map((x) => ({ name: x.name, url: x.value }));
  },
);

watch(
  () => JSON.stringify(state.tags),
  (val) => {
    formInfo.daoTag = JSON.parse(val)
      .filter((x) => !!x.value)
      .map((x) => x.value);
  },
);

watch(
  () => JSON.stringify(state.daoRelations),
  (val) => {
    formInfo.daoRelationship = JSON.parse(val)
      .filter((x) => !!x.relationshipType.value && x.dao.id)
      .map((x) => ({
        relationshipType: x.relationshipType.value,
        daoId: x.dao.id,
        name: x.dao.name,
      }));
  },
);

onMounted(() => {
  // check duplication of name
  state.name = formInfo.name;

  if (formInfo.daoType)
    state.daoType = daoTypes.value.find((x) => x.label == formInfo.daoType);

  // editStatus
  state.tags =
    formInfo.daoTag.length == 0
      ? [
          { id: uuid(), value: '' },
          { id: uuid(), value: '' },
        ]
      : formInfo.daoTag.map((x) => ({ id: uuid(), value: x }));
  state.externalLinks =
    formInfo.customizeLink.length == 0
      ? [
          {
            id: uuid(),
            name: '',
            value: '',
          },
        ]
      : formInfo.customizeLink.map((x) => ({
          id: uuid(),
          name: x.name,
          value: x.url,
        }));
  state.daoRelations =
    formInfo.daoRelationship.length == 0
      ? [{ id: uuid(), relationshipType: { label: '' }, dao: {} }]
      : formInfo.daoRelationship.map((x) => ({
          id: uuid(),
          relationshipType: daoRelations[x.relationshipType - 1],
          dao: {
            id: x.daoId,
            name: x.name,
          },
        }));
});
</script>

<style>
.dropfont {
  font-weight: normal !important;
  font-size: 16px !important;
}
</style>

<style scoped>
:deep(.checkbox-vars) {
  --n-size: 16px;
  --n-font-size: 16px;
}
</style>
